import type { SVGProps } from 'react';

const SvgJigsawIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={14} fill="currentColor" {...props}>
    <path d="M11.843 7.14c-.362-2.643 1.794-1.798 2.789-1.632L14.123.684l-3.632.34c.884 1.754 1.444 3.559-.763 3.626-1.992.06-.714-3.487-.714-3.487L5.73 1.47s2.232 5.487.07 6.347c-1.014.404-1.632-1.156-2.847-1.35C1.79 6.278.597 7.252.67 9.03c.118 2.9 2.01 2.885 2.738 2.308.585-.465 1.08-1.954 2.342-1.799 1.973.243 1.466 3.778 1.466 3.778l2.94-.417c-1.1-1.114-1.238-2.764.248-3.097 1.688-.378 2.074 1.594 1.505 2.788l3.424-.426-.467-4.428c-.636.389-2.737 1.5-3.024-.596" />
  </svg>
);

export default SvgJigsawIcon;
